import React from "react";
import { withStyles } from "material-ui/styles";
import classnames from "classnames";

const styles = {
  td: {
    padding: "5px 10px",
    border: "1px solid #e0e0e0"
  }
};

const CBodyCell = props => {
  const { classes, className, children, center, right, ...otherProps } = props;

  return (
    <td
      {...otherProps}
      className={classnames(classes.td, className)}
      style={{
        textAlign: (center && "center") || (right && "right")
      }}
    >
      {children}
    </td>
  );
};

export default withStyles(styles)(CBodyCell);



// WEBPACK FOOTER //
// ./src/uis/CTable/CBodyCell.jsx